export default __webpack_public_path__ + "static/media/gallery-wip-emitter_10.8b5e789e.jpg";